module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAXCAYAAABaiVzAAAABMklEQVRYR2NkGEBgPOvsegZGhgB0J/z980vxQqblA2o6jZGahpFq1qhHR2OU1DSDUD+adNHDLkm7Vp+R6b8iuvh3hj8Hl13ueE9OWBObR983KAiwMDAYoNvxj+HPE/6GJ3eIsZvoGE3RqZ/+n+F/BkYJ+fev5YLrrSeIsQxdDbEe/dyg4MDE9H8/un5Ghv8TuOoeFRJj96hH0UNpNEZHky7hnEPXPHpNvKEAw0n//j3Xet20Elmc2KT7dpsQ3z8mziRMM//fFfV6thlZnBYezd8X5Mf4n0EIo+C6Jt7wH0vYn9B62WBJjkefb5dQYGVkuY/FzA0iHk8Cae/R4PMMWKoixlGPjsYoaqL8i1bqjiZdBobRPEqo401KEzB/32hhNFq9jNajyHlqtNTFbBoNaKkLAASYg4oNHD8EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/header/small-logo.png
// module id = EdtJ
// module chunks = 0